import React, { memo, useState } from "react";
import classnames from "classnames";
import Icon from "../Icon";
import { useDidMount } from "../../hooks";
import "./SelectableCard.css";
import Card from "../Card/Card";

const CardItem = ({ selected, item, handleOnClick }) => {
    return (
        <Card
            className={classnames(`selectable-card__container`, {
                "selectable-card__container--selected": selected,
            })}
            role="button"
            aria-label={item.description}
            onClick={() => handleOnClick(item)}
            data-testid="card-item"
        >
            <div className="selectable-card__content">
                <Icon
                    showTitle={false}
                    name={selected ? item.selectedIcon : item.icon}
                    width={item.width || 36}
                    image={selected ? item.imageSelected : item.image}
                />
            </div>
            <span>{item.description}</span>
        </Card>
    );
};

const SelectableCard = ({ defaultValue, items, handleOnSelect, width, ...rest }) => {
    const [selected, setSelected] = useState(defaultValue);
    useDidMount(() => {
        if (defaultValue) {
            handleOnSelect(defaultValue);
        }
    });
    const handleOnClick = ({ id }) => {
        setSelected(id);
        handleOnSelect(id);
    };
    return (
        <div
            className="selectable-card"
            style={{ gridTemplateColumns: `repeat(${items.length},${width || "1fr"})` }}
            data-testid="selectable-card"
            {...rest}
        >
            {items &&
                items.map(item => (
                    <CardItem
                        key={item.id}
                        selected={selected === item.id}
                        handleOnClick={handleOnClick}
                        item={item}
                    />
                ))}
        </div>
    );
};

SelectableCard.defaultProps = {
    items: [],
    width: "89px",
};

export default memo(SelectableCard);
